export default {"src":"/_next/static/media/clock.ade7a805.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};